import React from 'react';
import { useWorkspaceBranding } from '../../branding/BrandingContext';
import './app-shell.css';

function AppFooter(): React.JSX.Element {
    const { appName, footerContactLine } = useWorkspaceBranding();
    return (
        <footer className="app-footer">
            <div className="app-footer-inner">
                <span>© {new Date().getFullYear()} {appName}</span>
                {footerContactLine ? <span>{footerContactLine}</span> : null}
            </div>
        </footer>
    );
}

export default AppFooter;
